.bg{flex-wrap:wrap;}